function initContentMenuTabs(rootEl) {
  const buttons = Array.from(rootEl.querySelectorAll('[data-menu-category-button]'));
  const panels = Array.from(rootEl.querySelectorAll('[data-menu-category-panel]'));

  if (!buttons.length || !panels.length) {
    return;
  }

  const activateCategory = (targetId, shouldScrollToTop = false) => {
    buttons.forEach((button) => {
      const isActive = button.dataset.target === targetId;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    panels.forEach((panel) => {
      const isActive = panel.id === targetId;
      panel.classList.toggle('is-active', isActive);
      // eslint-disable-next-line no-param-reassign
      panel.hidden = !isActive;
    });

    if (shouldScrollToTop) {
      rootEl.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  };

  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      activateCategory(button.dataset.target, true);
    });
  });

  activateCategory(buttons[0].dataset.target);
}

function initContentMenu() {
  const rootEls = document.querySelectorAll('[data-menu-tabs]');

  rootEls.forEach((rootEl) => {
    initContentMenuTabs(rootEl);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initContentMenu();
});
